import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// `/create-round` and `/create-round/:groupId` are now thin redirects into
// the new 3-screen wizard at `/create-round/<mode>/<step>`. The wizard
// replaces the old WHO-first selector; users pick Solo / Friends / Group on
// step 3 instead.
function CreateRound({ groups, loading }) {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (groupId && groupId !== 'solo') {
      // Number-like groupId - preselect the group in the wizard.
      const parsedId = parseInt(groupId, 10);
      if (Number.isNaN(parsedId)) {
        navigate('/create-round/smart/when', { replace: true });
        return;
      }
      // Wait for groups to load so we can hand the full group object through.
      if (loading) return;
      const group = groups?.find(g => g.id === parsedId);
      if (group) {
        const preSelectedMemberIds =
          new URLSearchParams(location.search).get('members')?.split(',').filter(Boolean) || [];
        navigate('/create-round/smart/when', {
          replace: true,
          state: { selectedGroup: group, preSelectedMemberIds },
        });
      } else {
        navigate('/create-round/smart/when', { replace: true });
      }
    } else {
      // No groupId, or legacy 'solo' shortcut - both land on the wizard start.
      navigate('/create-round/smart/when', { replace: true });
    }
  }, [groupId, groups, loading, navigate, location.search]);

  return (
    <div className="min-h-screen bg-app flex items-center justify-center">
      <div className="text-text-muted text-sm">Loading…</div>
    </div>
  );
}

export default CreateRound;
